import { INTERSTITIALS_UPDATED } from 'redux/modules/interstitials/actions/types';

export const updateInterstitialsPage = () => ({
  type: INTERSTITIALS_UPDATED,
});
